import i18n from '@/plugins/i18n';

export class BusinessOrderSkuAttribute {
    public attributeName: any | null = null;
    public valueName: any | null = null;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, {
            attributeName: json.item1,
            valueName: json.item2
        });
    }
}
